// extracted by mini-css-extract-plugin
export default {"totalRow":"paymentsTable_totalRow__6w8qR"};